import { emitBrowserMainStoreSet } from '../browser-store'
import type { BrowserFallbackRegistry } from './types'

const GS = 'global.state'

export const systemBrowserFallbacks: BrowserFallbackRegistry = {
  model: {
    fetchModels: () => [],
    removeModel: () => false,
  },
  asr: {
    getASRInputDevices: () => [],
    startDictation: (callOrigin: unknown) => {
      const origin = callOrigin as string
      emitBrowserMainStoreSet(GS, origin + '.dictation', '')
      emitBrowserMainStoreSet(GS, 'asr.dictationOrigin', origin)
      emitBrowserMainStoreSet(GS, 'asr.dictationStartTime', Date.now())
      emitBrowserMainStoreSet(GS, 'asr.isRunning', true)
    },
    stopDictation: (payload: unknown) => {
      const { callOrigin, cancelled } = payload as { source: number; callOrigin: string; cancelled?: boolean }
      if (cancelled) {
        emitBrowserMainStoreSet(GS, 'asr.dictationOrigin', '')
        emitBrowserMainStoreSet(GS, 'asr.isRunning', false)
        return
      }
      // Signal the renderer-side bridge in useAudioRuntime to collect text and stop
      emitBrowserMainStoreSet(GS, 'voiceMode.originAwaitingSegment', callOrigin)
      emitBrowserMainStoreSet(GS, 'asr.browserDictationPendingStop', callOrigin)
    },
  },
  updater: {
    getStatus: () => ({ status: 'idle' }),
    checkForUpdate: () => false,
    checkForUpdates: () => false,
    downloadUpdate: () => false,
    installUpdate: () => false,
    quitAndInstall: () => false,
  },
}
